// Whose book the portal is viewing (MAG-168). One localStorage record,
// `{by, user}`: `by` is the signed-in user it belongs to (a pick never
// survives a sign-in change), `user` the picked person or null for everyone
// the caller may see. The axios clients read it on every request and send
// `X-Scope-User`; core decides whether the caller may see that person.
// Kept outside React so the API modules can read it without a context.

const KEY = 'touchpoint_portal_scope';

export type StoredScope = { by: string; user: string | null };

export const readScope = (): StoredScope | null => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as StoredScope) : null;
  } catch {
    return null;
  }
};

export const writeScope = (scope: StoredScope | null) => {
  try {
    if (scope) localStorage.setItem(KEY, JSON.stringify(scope));
    else localStorage.removeItem(KEY);
  } catch {
    // storage unavailable — the pick simply does not persist
  }
};

/** The picked user id to send as X-Scope-User for this signed-in user, or undefined. */
export const scopeUserFor = (signedInId: string | undefined): string | undefined => {
  const s = readScope();
  return s && s.by === signedInId && s.user ? s.user : undefined;
};
